import { inject, provide, useShadowRoot } from 'vue'

export const SHADOW_ROOT_INJECTION_KEY = Symbol('shadowRoot')

export const useAppShadowRoot = () => {
  inject<ShadowRoot | null>(SHADOW_ROOT_INJECTION_KEY)
  return inject<ShadowRoot | null>(SHADOW_ROOT_INJECTION_KEY)
}

export const useAppShadowRootProvider = () => {
  const shadowRoot = useShadowRoot()
  provide(SHADOW_ROOT_INJECTION_KEY, shadowRoot)
}
